// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"menuText": "#bfcbd9",
	"menuActiveText": "#00c1b3",
	"subMenuActiveText": "#f4f4f5",
	"menuBg": "#000f29",
	"menuHover": "#00c1b3",
	"subMenuBg": "#000",
	"subMenuHover": "#00c1b3",
	"sideBarWidth": "210px",
	"primaryColor": "#2b9ef7"
};
module.exports = exports;
